import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";

const Container = styled.div``;
const Text = styled.div``;
const Domain = styled.div``;

const PlaceholderLinkExcerpt = styled(({className, post}) => {
    return (
        <Container className={className}>
            <Text>
                <Domain>
                    {post?.domain || ''}
                </Domain>
            </Text>
        </Container>
    );
})`
  border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : '#dddddd'};
  margin: 0 8px;
  ${Text} {
    padding: 12px;
  }
  ${Domain} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? 'rgba(255,255,255,.6)' : themecolors.light_medium_impact_text};
  }
`;

export default PlaceholderLinkExcerpt;
